import { injectPlatform } from "./internal";

// PDT logger (client metric logging)
export { log as pdtLog } from "./pdtLogger";
export type { PdtEventPayload, PdtLogParams } from "./pdtLogger";
export {
  initGlobalErrorLogging,
  storePageTransitionStart,
} from "./pdtLogger/globalErrorLogging";

export const pushEvent = (eventObj: any) => {
  const isClientSide =
    typeof navigator !== "undefined" && typeof window !== "undefined";
  if (!isClientSide) return;

  injectPlatform(eventObj);

  // @ts-ignore
  window.adobeDataLayer = window.adobeDataLayer || [];
  // @ts-ignore
  window.adobeDataLayer.push(eventObj);
};
